import React from "react"
import {Provider} from "react-redux"
import {MemoryRouter} from "react-router"
import axios from "axios"
import _ from "lodash"
import keycloak from "./keycloak"
import "./App.scss"
import RefDb from "./metstat/RefDb"
import NavBar from "./core/components/NavBar"
import Footer from "./@biocrates-common-repo/core/components/footer/Footer"
import store from "./redux/store/store"
import ErrorReportWrapper from "./common/error-report/ErrorReportWrapper"
import env from "./@biocrates-common-repo/core/context/Env"

export function getCSRFToken(tokenName: string) {
    let cookieValue = null
    if (!_.isEmpty(document.cookie)) {
        const cookies = document.cookie.split(";")
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.includes(tokenName)) {
                cookieValue = decodeURIComponent(
                    cookie.substring(tokenName.length + 1)
                )
                break
            }
        }
    }
    return cookieValue
}

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        // Do something before request is sent
        const {token} = keycloak
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
            // TODO
            config.withCredentials = true
            config.headers[
                config.xsrfHeaderName || "X-XSRF-TOKEN"
            ] = getCSRFToken(config.xsrfCookieName || "XSRF-TOKEN")
        }
        return config
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error)
    }
)

function App() {
    return (
        <Provider store={store}>
            <div className="AppContainer">
                <MemoryRouter>
                    <header>
                        <NavBar />
                    </header>
                    <main>
                        <RefDb />
                    </main>
                    <footer>
                        <Footer
                            links={[
                                {
                                    label: "Support",
                                    href:
                                        "mailto:support@biocrates.com?subject=Support%20request",
                                },
                                {
                                    label: "Help",
                                    href: env("USER_MANUAL_URL"),
                                },
                            ]}
                        />
                    </footer>
                    <ErrorReportWrapper />
                </MemoryRouter>
            </div>
        </Provider>
    )
}

export default App
